import { PropTypes } from "base/react-libs";
import { PageHeader, Icon, Button } from "@evertrue/et-components";
import EverTrue from "app";
import JourneyPauseContainer from "./journeys-pause-container";

const JourneysBanner = ({ journey = {} }) => {
  const title = journey.name || "Cadences";
  return (
    <div className="journeys-banner">
      <div className="journey-banner-item first">
        <div className="title-container">
          <Icon
            icon="chevron-left"
            size={2}
            className="settings-back"
            onClick={() => {
              EverTrue.UrlManager.navigate("/home", true, false);
            }}
          />
          <PageHeader title={title} />
        </div>
      </div>
      <div className="journey-banner-item middle">
        <JourneyPauseContainer />
      </div>
      <div className="journey-banner-item last">
        <Button type="simple" href="settings">
          <Icon icon="gear" size={1} className="homepage-settings-icon" />
        </Button>
      </div>
    </div>
  );
};

JourneysBanner.propTypes = {
  journey: PropTypes.object,
};

export default JourneysBanner;
